

export enum TipoDeFormatacao {
  Italico,
  Negrito,
  Sublinhado,
  Lista
}
